(function () {
  if(!document.querySelector(".lp-page")) return this;
  
  const menu = document.querySelectorAll(".lp-toggle h3");

  function toggle() {
    if(!document.querySelector(".lp-page")) return this;
  
    const content = this.nextElementSibling;
    this.classList.toggle("is-active");
    content.classList.toggle("is-open");
  }

  function toggleKey(e) {
    if (e.keyCode === 13) {
      toggle.call(this);
    }
  }

  menu.forEach(function (item) {
    item.addEventListener("click", toggle);
    item.addEventListener("keydown", toggleKey);
    item.tabIndex = 0;
  });

  function toggleAll() {
    const isActive = Array.from(menu).every(function (question) {
      return question.classList.contains('is-active');
    });

    const isOpen = Array.from(menu).every(function (question) {
      const content = question.nextElementSibling;
      return content.classList.contains('is-open');
    });

    menu.forEach(function (question) {
      if (isActive) {
        question.classList.remove('is-active');
      } else {
        question.classList.add('is-active');
      }

      if (isOpen) {
        const content = question.nextElementSibling;
        content.classList.remove('is-open');
      } else {
        const content = question.nextElementSibling;
        content.classList.add('is-open');
      }
    });

  }

  function toggleKeyAll(e) {
    if (e.keyCode === 13) {
      toggleAll();
    }
  }

})();

